export default __webpack_public_path__ + "static/media/CanonesBG.64789d5a.jpg";